import React from 'react';
import PropTypes from 'prop-types';

import {
  SortableList, SortableListRow, keyOf, reorderById, reorderInState, withDndSensors,
} from './shared/dndSortable';
import { processInitialColumns } from './shared/columnFields';
import Parameter from './sortingParameters/Parameter';

export { reorderById };

class SortingParameters extends React.Component {
  static propTypes = {
    sorting_parameters: PropTypes.array.isRequired,
    disabled: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      sortingParameters: processInitialColumns(this.props.sorting_parameters, this.columnId),
    };
  }

  columnId = (column) => `${column.type}-${column.name}`;

  onDragEnd = (event) => reorderInState(event, this, 'sortingParameters');

  render() {
    const itemIds = this.state.sortingParameters.map(keyOf);

    return (
      <div>
        <div className="col-xs-12">
          <div>
            <div className="row mb-10">
              <div className="col-xs-1 col-drag-handle"></div>
              <div className="col-xs-5">
                <div className="text-semibold">Parameters Order</div>
              </div>
              <div className="col-xs-1"></div>
            </div>

            <SortableList
              sensors={this.props.__sensors}
              items={itemIds}
              onDragEnd={this.onDragEnd}
            >
              {this.state.sortingParameters.map((column, index) => (
                <SortableListRow
                  key={column.key}
                  id={keyOf(column)}
                  className="row pb-10 pt-10"
                  iconClassName="icon-three-bars text-muted cursor-move"
                >
                  <Parameter index={index} column={column} baseInputName="project[sorting_parameters]" />
                </SortableListRow>
              ))}
            </SortableList>
          </div>
        </div>
      </div>
    );
  }
}

export default withDndSensors(SortingParameters);
